export const DAYS = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

export const DAY_LABELS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const formatHourShort = (hour) => {
  if (hour === 0) return '12a';
  if (hour < 12) return `${hour}a`;
  if (hour === 12) return '12p';

  return `${hour - 12}p`;
};

export const formatHourFull = (hour) => {
  if (hour === 0) return '12:00 AM';
  if (hour < 12) return `${hour}:00 AM`;
  if (hour === 12) return '12:00 PM';

  return `${hour - 12}:00 PM`;
};

// --- Hours-of-operation ---

const DEFAULT_BUSINESS_HOURS = { start: 6, end: 22 };

/**
 * Read hours-of-operation from sessionStorage (set by ScheduleGenerationConfigModal).
 * Returns a per-day map: { Monday: { start: 9, end: 17, closed: false }, ... }
 * Falls back to DEFAULT_BUSINESS_HOURS when no config is available.
 */
export const getHoursOfOperation = () => {
  const defaultConfig = {};
  DAYS.forEach((day) => {
    defaultConfig[day] = { ...DEFAULT_BUSINESS_HOURS, closed: false };
  });

  try {
    const saved = sessionStorage.getItem('scheduleGeneratorConfig');
    if (!saved) return defaultConfig;

    const config = JSON.parse(saved);
    if (!config.hoursOfOperation) return defaultConfig;

    const result = {};
    DAYS.forEach((day) => {
      const key = day.toLowerCase();
      const dayConfig = config.hoursOfOperation[key];

      if (!dayConfig || dayConfig.start === null || dayConfig.end === null) {
        result[day] = { start: 0, end: 0, closed: true };

        return;
      }

      const startHour = new Date(dayConfig.start).getHours();
      const endHour = new Date(dayConfig.end).getHours();
      result[day] = { start: startHour, end: endHour, closed: false };
    });

    return result;
  } catch {
    return defaultConfig;
  }
};

/**
 * Check if a given hour is outside business hours for a specific day.
 * @param {number} hour - 0-23
 * @param {number} dayIndex - index into DAYS array (0=Monday)
 * @param {object} hoursConfig - from getHoursOfOperation()
 */
/**
 * Structured deep clone for demand data objects.
 * Shape: { [roleId]: { [day]: { [timeSlot]: number } } }
 * ~5-10x faster than JSON.parse(JSON.stringify(...)) for this known shape.
 */
export const deepCloneDemandData = (data) => {
  const clone = {};
  for (const roleId of Object.keys(data)) {
    clone[roleId] = {};
    for (const day of Object.keys(data[roleId])) {
      clone[roleId][day] = { ...data[roleId][day] };
    }
  }

  return clone;
};

export const isOffHours = (hour, dayIndex, hoursConfig) => {
  const day = DAYS[dayIndex];
  const config = hoursConfig?.[day];

  if (!config) {
    return (
      hour < DEFAULT_BUSINESS_HOURS.start || hour >= DEFAULT_BUSINESS_HOURS.end
    );
  }

  if (config.closed) return true;

  return hour < config.start || hour >= config.end;
};
